var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSimboloGrabaloCirculoRelleno = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logosimbolo_blanco_en_circulo",
    "data-name": "Logosimbolo blanco en circulo",
    viewBox: "0 0 842 842",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a3da;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 421,
    cy: 421,
    r: 421
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_simbolo",
    "data-name": "Logo simbolo"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 489.35,
    cy: 612.65,
    r: 111.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.7,313.25V492.6H431.35A179.35,179.35,0,1,1,610.7,313.25Z",
    transform: "translate(-10 -10)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSimboloGrabaloCirculoRelleno, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/simbolo_grabalo_circulo_relleno.e87ba854.svg";
export { ForwardRef as ReactComponent };